export interface EnvConfig {
  apiUrl: string
}

function resolveConfig(): EnvConfig {
  return {
    apiUrl: (import.meta.env.VITE_API_URL || 'http://localhost:3040').replace(/\/+$/, ''),
  }
}

export const env: EnvConfig = resolveConfig()
